import { HttpResponse, http, passthrough } from 'msw';

import { STORE_EXPENSE_WORKFLOW_ERROR_CODE } from '../../app/feature/store-expense/models/store-expense-workflow-error';
import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.storeExpense;
const envServiceUrl = module.url;

// Workflow Validation V.2 (CJXPM-2914) — ตัวอย่าง response จริงจาก API Spec (`API response workflow v2`)
// ทุกเคสใช้ code เดียวกัน ต่างกันที่ messageTh ที่ BE ประกอบมาให้แล้ว
const ERROR_PRESETS: Record<string, string> = {
  workflowNotConfigured: 'เนื่องจากส่วนกลางยังไม่ได้ตั้งค่าสายการอนุมัติ<br/>กรุณาติดต่อส่วนกลาง',
  // BE ตอบ messageTh เป็นค่าว่างในเคสนี้ (mark ⚠️ ไว้ใน spec) — ใช้ดูว่า modal ไม่โล่ง
  storeRequiredButMissing: '',
  storeNotInRegionalStructure:
    'ไม่พบร้าน <b>“10001”</b> ในโครงสร้างองค์กร<br/>(Regional Structure) ไม่สามารถระบุผู้อนุมัติได้<br/>กรุณาติดต่อส่วนกลาง',
  regionalStructureIncomplete:
    'เนื่องจากยังไม่ได้กำหนดผู้อนุมัติในโครงสร้างองค์กร<br/>(Regional Structure) ของร้าน <b>“10001”</b><br/>ให้ครบถ้วน กรุณาติดต่อส่วนกลาง',
  storeNotInApprovalStep:
    'เนื่องจากยังไม่ได้กำหนดผู้อนุมัติสำหรับร้าน<br/> <b>“10001”</b> ในขั้นตอน <b>“Area Manager”</b><br/>กรุณาติดต่อส่วนกลาง',
  requesterNotConfigured:
    'เนื่องจากไม่พบผู้อนุมัติสำหรับคำขอของคุณ<br/>ในขั้นตอน <b>“Store Manager”, “Area Manager”</b><br/>กรุณาติดต่อส่วนกลาง',
  approverDepartmentChanged: 'เนื่องจากผู้อนุมัติในหน่วยงานของคุณ<br/>ไม่สามารถอนุมัติได้แล้ว กรุณาติดต่อส่วนกลาง',
  noApproverInStep:
    'เนื่องจากผู้อนุมัติในขั้นตอน <b>“Finance Manager”</b><br/>ไม่สามารถอนุมัติได้แล้ว กรุณาติดต่อส่วนกลาง',
  approverInactive:
    'เนื่องจากผู้อนุมัติ ในขั้นตอน <b>“Store Manager”</b><br/>ไม่สามารถอนุมัติได้ (บัญชีถูกยกเลิกการใช้งาน)<br/>กรุณาติดต่อส่วนกลาง',
  exceedSpendingLimit: 'เนื่องจากยอดที่ขอเกินวงเงินอนุมัติของผู้อนุมัติ<br/>กรุณาติดต่อส่วนกลาง'
};

// ใส่ชื่อ preset (เช่น 'approverInactive') เพื่อบังคับให้ submit ตอบ error นั้น; null = ยิงไป BE จริง
const ACTIVE_PRESET: string | null = null;

const submitEvidence = () => {
  if (!ACTIVE_PRESET) {
    return passthrough();
  }

  return HttpResponse.json(
    {
      code: STORE_EXPENSE_WORKFLOW_ERROR_CODE,
      message: 'Unable to create the workflow.',
      messageEn: 'Unable to create the workflow.',
      messageTh: ERROR_PRESETS[ACTIVE_PRESET]
    },
    { status: 400 }
  );
};

// Regenerate Approval Workflow (CJXPM-2914) — preset สำหรับดู activity `สร้างสายอนุมัติใหม่` บน History sidebar
// true = ตอบประวัติจำลอง (activity เดิม + activity ใหม่); false = ยิงไป BE จริง
const MOCK_REGENERATE_WORKFLOW_HISTORY: boolean = false;

const MOCK_AUDIT_LOGS = [
  {
    activity: 'บันทึกหลักฐาน',
    editBy: 'u001',
    editByName: 'Somchai Jaidee',
    editByLocalName: 'สมชาย ใจดี',
    editDate: '2026-09-01T03:15:00.000Z'
  },
  {
    activity: 'สร้างสายอนุมัติใหม่',
    editBy: 'u001',
    editByName: 'Somchai Jaidee',
    editByLocalName: 'สมชาย ใจดี',
    editDate: '2026-09-01T03:16:00.000Z'
  }
];

const history = ({ params }: { params: Record<string, string> }) => {
  if (!MOCK_REGENERATE_WORKFLOW_HISTORY) {
    return passthrough();
  }

  return HttpResponse.json({ docNo: params['docNo'], auditLogs: MOCK_AUDIT_LOGS });
};

export const handlers = [
  http.post(env.serverUrl + envServiceUrl + '/stores/:storeNo/store-expense-request/submit-evidence', submitEvidence),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/:storeNo/store-expense-request/submit-send-back-evidence',
    submitEvidence
  ),
  http.get(env.serverUrl + envServiceUrl + '/stores/:storeNo/store-expense-request/:docNo/history', history)
];
